import * as React from "react";
const defaultValue = {
  MINIMAL: [],
  SMALL: [],
  MEDIUM: [],
  LARGE: [],
  COMPLETE: []
};
const AddressConfigurationContext = React.createContext(defaultValue);
const AddressConfigurationProvider = ({
  children,
  settings = defaultValue
}) => /* @__PURE__ */ React.createElement(AddressConfigurationContext.Provider, { value: settings }, children);
const useAddressConfiguration = () => React.useContext(AddressConfigurationContext);
export {
  AddressConfigurationProvider as default,
  defaultValue,
  useAddressConfiguration
};
//# sourceMappingURL=AddressConfigurationContext.js.map
